<script setup lang="ts">
import type { PropType } from 'vue';
import type { UiLoaderSizes } from '@mop/ui2/types';

defineOptions({
  name: 'Ui2Loader',
});

defineProps({
  size: {
    type: String as PropType<UiLoaderSizes>,
    default: 'md',
  },
});
</script>

<template>
  <div :class="['ui-loader', `ui-loader--${size}`]">
    <span class="ui-loader__dot"></span>
    <span class="ui-loader__dot"></span>
    <span class="ui-loader__dot"></span>
  </div>
</template>

<style lang="scss">
$jumpingAnimationDuration: 1s;

@keyframes jumpingAnimation {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}

.ui-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: $space-48;
  height: $space-48;
  gap: $space-4;
}

.ui-loader--sm {
  width: 24px;
  height: 24px;
  gap: $space-1;

  .ui-loader__dot {
    width: 2px;
    height: 2px;
  }
}

.ui-loader--md {
  width: 32px;
  height: 32px;
  gap: $space-2;

  .ui-loader__dot {
    width: 3px;
    height: 3px;
  }
}

.ui-loader__dot {
  transform: scale(1);
  margin: 0 2px;
  width: 4px;
  height: 4px;
  border-radius: $border-radius-rounded-full;
  background-color: currentColor;

  &:nth-child(1) {
    animation: jumpingAnimation $jumpingAnimationDuration 0.1s ease-in infinite;
  }

  &:nth-child(2) {
    animation: jumpingAnimation $jumpingAnimationDuration 0.2s ease-in infinite;
  }

  &:nth-child(3) {
    animation: jumpingAnimation $jumpingAnimationDuration 0.3s ease-in infinite;
  }
}
</style>
